/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps, IconSize} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Selected Filter Icon component.
 */
export const SelectedFilterIcon = ({
  size = IconSize.largeMedium,
  color = dlsColor('paleBlue')
}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({color, size});
  return (
    <svg width='36' height='36' viewBox='0 0 36 36' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g filter='url(#filter0_d_21088_94276)'>
        <rect x='2' y='1' width={iconSize} height={iconSize} rx='8' fill={iconColor} shapeRendering='crispEdges' />
        <path d='M22.6003 12.7381C22.7807 12.405 22.5395 12 22.1606 12H12.8394C12.4605 12 12.2193 12.405 12.3997 12.7381L15.4653 18.3987C15.5049 18.4718 15.5256 18.5536 15.5256 18.6368V21.4096C15.5256 21.6289 15.6686 21.8227 15.8781 21.8874L18.8339 22.8001C19.1555 22.8994 19.4814 22.6589 19.4814 22.3223V18.5127C19.4814 18.5112 19.4802 18.5101 19.4788 18.5101C19.4768 18.5101 19.4755 18.5079 19.4765 18.5062L22.6003 12.7381Z' stroke={dlsColor('darkTeal')} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      </g>
      <defs>
        <filter id='filter0_d_21088_94276' x='0' y='0' width='36' height='36' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dy='1' />
          <feGaussianBlur stdDeviation='1' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_21088_94276' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_21088_94276' result='shape' />
        </filter>
      </defs>
    </svg>
  );
};

export default SelectedFilterIcon;
